import ModalContainer from 'components/modal/modal-container'

import ModalActions from 'components/modal/modal-actions'
import { Button } from '@mui/material'

import { closeModal } from 'actions/app'

import { unArchiveFields } from 'api/field'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

export default function RestoreFields(props) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { selectedFieldIds, callback } = props

  const closePopup = () => dispatch(closeModal())

  const restore = () => {
    if (selectedFieldIds && selectedFieldIds.length > 0) {
      //@ts-expect-error
      dispatch(unArchiveFields(selectedFieldIds, callback))
      dispatch(closeModal())
    } else {
      dispatch(closeModal())
    }
  }

  return (
    <ModalContainer>
      <div>
        {t('restore_items', {
          count: selectedFieldIds.length,
          item: selectedFieldIds.length > 1 ? t('fields') : t('field'),
        })}
      </div>
      <ModalActions>
        <Button variant="contained" color="secondary" onClick={closePopup}>
          {t('cancel')}
        </Button>
        <Button variant="contained" color="primary" onClick={restore}>
          {t('restore')}
        </Button>
      </ModalActions>
    </ModalContainer>
  )
}
